<template>
    <div>
        <channel-list
            key="channelListA"
            :class="{sync: !entity.system}"
            :channel-ids="selectedChannelIds"
            :all-channels="allChannels"
            :title="$gettext('Kanály ve skupině')"
            :sortable="true"
            :isSystem="entity.system"
            :actionButtonTitle="$gettext('Odebrat kanály')"
            @buttonClick="_onChannelsRemove"
            @sorted="_onChannelsSorted"
        />

        <channel-list
            key="channelListB"
            v-if="!entity.system"
            :channel-ids="availableChannelIds"
            :all-channels="allChannels"
            :title="$gettext('Dostupné kanály')"
            :actionButtonTitle="$gettext('Přidat kanály')"
            @buttonClick="_onChannelsAdd"
        />
    </div>
</template>

<script>
import ChannelList from "./channelList";
export default {
    name: "channelLists",
    components: {ChannelList},
    props: ["entity", "allChannels"],
    methods: {
        _onChannelsRemove(channelIds) {
            this.entity.channel_ids = this.entity.channel_ids.filter((channelId) => !channelIds.includes(channelId));
        },
        _onChannelsAdd(channelIds) {
            this.entity.channel_ids = [...this.entity.channel_ids, ...channelIds];
        },
        _onChannelsSorted(channelIds) {
            this.entity.channel_ids = [...channelIds];
        }
    },
    computed: {
        allChannelIds() {
            return Object.keys(this.allChannels).map((value) => ~~value);
        },
        availableChannelIds() {
            return this.allChannelIds.filter((id) => !this.selectedChannelIds.includes(id));
        },
        selectedChannelIds() {
            return this.entity.channel_ids;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/views/channelGroups/detail/channelLists.vue